import React, { useState, useEffect, useCallback, useContext } from "react";
import ProductDataService from "../../services/products";
import AccountDataService from "../../services/account";
import { CartContext } from "../context/CartContext";
import {
  Container,
  Table,
  Card,
  Row,
  Text,
  Spacer,
  Image,
  Button
} from '@nextui-org/react';
import { Divider } from "@mui/material";

import CartProductCard from "./CartProductCard";
import CheckoutForm from "./CheckoutForm";
import CheckoutPopover from "./CheckoutSuccessPage";

import { Navbar2 } from "../NavBars";
import './CartPage.css';
import { useMediaQuery } from 'react-responsive';

const CartPage = ({ user }) => {
  const isSmallScreen = useMediaQuery({ query: '(max-width: 959px)' });

  const [cart, setCart] = useState([]);
  const [articles, setArticles] = useState([]);
  const [products, setProducts] = useState([]);
  const [selectedItems, setSelectedItems] = useState(new Set([]));
  const [popoverVisible, setPopoverVisible] = useState(false);
  const [totalPrice, setTotalPrice] = useState(0);
  const { cartItems, setCartItems } = useContext(CartContext);

  const retrieveCart = useCallback(() => {
    if (user) {
      AccountDataService.getCart(user.id)
        .then(response => {
          const cartItems = response.data.cart;
          setCart(cartItems);
          const allItemIndexes = cartItems.map((_, index) => index.toString());
          setSelectedItems(new Set(allItemIndexes));
        })
        .catch(console.error);
    }
  }, [user]);

  const updateCart = (newCart, formerIndex) => {
    if (user) {
      let data = { _id: user.id, cart: newCart };
      if (newCart.length < cart.length && formerIndex !== undefined) {
        let selected = new Set([...selectedItems]);
        selected.delete(formerIndex.toString());
        let updated = [...selected].map(idx =>
          parseInt(idx) > formerIndex ? (parseInt(idx) - 1).toString() : idx
        );
        setSelectedItems(new Set(updated));
      }
      // AccountDataService.updateCart(data)
      //   .then(() => setCart(newCart))
      //   .catch(console.error);
       AccountDataService.updateCart(data)
      .then(() => {
        setCartItems(newCart); // ✅ context update
         setCart(newCart); // ❌ optional: use one or the other
      })
      .catch(console.error);
    }
  };

  useEffect(() => {
    retrieveCart();
  }, [retrieveCart]);

  useEffect(() => {
    if (cart.length > 0) {
      ProductDataService.getArticleByIds(cart.map(item => item.article_id))
        .then(response => {
          let info = response.map((res, idx) => ({
            ...res.data,
            ...cart[idx]
          }));
          setArticles(info);
        })
        .catch(console.error);
    } else {
      setArticles([]);
    }
  }, [cart]);

  useEffect(() => {
    if (articles.length > 0) {
      ProductDataService.getProductByIds(articles.map(item => item.product_code))
        .then(response => {
          setProducts(response.map(res => res.data));
        })
        .catch(console.error);
    } else {
      setProducts([]);
    }
  }, [articles]);

  useEffect(() => {
    let newCart = [...cart];
    if (popoverVisible) {
      let remove = [...selectedItems].map(i => parseInt(i)).sort((a, b) => b - a);
      remove.forEach(i => newCart.splice(i, 1));
      setSelectedItems(new Set([]));
      updateCart(newCart);
    }
  }, [popoverVisible]);

  useEffect(() => {
    const items = [...selectedItems]
      .map(idx => articles[parseInt(idx)])
      .filter(Boolean);
    const total = items.reduce((sum, item) => sum + item.price * item.num, 0);
    setTotalPrice(total);
  }, [selectedItems, articles]);

  const genSpacers = useCallback(() => {
    let itemNum = cart.length;
    let spacerNum = itemNum === 0 ? 4 : Math.max(5 - itemNum, 0);
    return [...Array(spacerNum).keys()].map(idx => <Spacer y={9.5} key={idx} />);
  }, [cart]);

  return (
    <div className="App">
      <Navbar2 />
      <Spacer y={1} />

      <Container className="CartList">
        {cart.length > 0 ? (
          <Card css={{ background: "rgba(255,255,255,0.8)" }}>
            <Card.Body>
              <Table
                selectionMode="multiple"
                hoverable={false}
                shadow={false}
                color="default"
                selectedKeys={selectedItems}
                onSelectionChange={setSelectedItems}
                css={
                  isSmallScreen
                    ? { background: "transparent" }
                    : {
                        background: "transparent",
                        paddingLeft: "5%",
                        paddingRight: "calc(4*$sm)",
                        paddingBottom: "3%"
                      }
                }
              >
                <Table.Header>
                  <Table.Column css={{ background: "transparent", textAlign: "center" }}>
                    <Text className="cart-title">Shopping Cart</Text>
                  </Table.Column>
                </Table.Header>
                <Table.Body>
                  {articles.length > 0 && products.length > 0 &&
  articles.map((article, index) => {
    const product = products[index];
    if (!article || !product) return null; // <--- 🛑 SAFETY CHECK

    return (
      <Table.Row key={index}>
        <Table.Cell>
          <CartProductCard
            key={article.article_id}
            user={user}
            cart={cart}
            updateCart={updateCart}
            article={article}
            product={product}
          />
        </Table.Cell>
      </Table.Row>
    );
  })
}

                </Table.Body>
              </Table>

              {selectedItems.size > 0 && (
                <Container
                  className="calculator"
                  css={isSmallScreen ? {} : { paddingRight: "calc(11*$sm)" }}
                >
                  <Row justify="flex-end">
                    <Text className="cart-text-regular">
                      Order Value: {"$ " + totalPrice.toFixed(2)}
                    </Text>
                  </Row>
                  <Row justify="flex-end">
                    <Text className="cart-text-regular">Shipping Fee: $ 5.00</Text>
                  </Row>
                  <Divider variant="inset" component="p" />
                  <Row justify="flex-end">
                    <Text size={23} className="cart-text-block">
                      Total: {"$ " + (5 + totalPrice).toFixed(2)}
                    </Text>
                  </Row>
                </Container>
              )}

              <Spacer y={1} />
              {selectedItems.size > 0 && (
                <Container className="Checkout" style={{ justifyContent: "center" }}>
                  <CheckoutForm
                    user={user}
                    articles={[...selectedItems].map(idx => articles[parseInt(idx)])}
                    totalPrice={totalPrice}
                    popoverVisible={popoverVisible}
                    setPopoverVisible={setPopoverVisible}
                  />
                </Container>
              )}
            </Card.Body>
          </Card>
        ) : (
          <Container>
            <Spacer y={3} />
            <Image src="./images/emptyCart.png" width={"44%"} />
            <Text className="cart-text-block" size={20}>
              Your cart is empty!
            </Text>
          </Container>
        )}

        <CheckoutPopover visible={popoverVisible} setVisible={setPopoverVisible} />
      </Container>

      {genSpacers()}
    </div>
  );
};

export default CartPage;
